import { FETCH_EVOLUTIVE_CROSS_RESULT, LIST_EVOLUTIVE_CROSS_CONFIG } from "../actions/configs";
import { FETCH_ALTERNATIVES_BY_GROUP_QUESTIONS, FETCH_EVOLUTIVE_CROSSED_ALTERNATIVES_AND_QUESTIONS, FETCH_EVOLUTIVE_CROSSED_QUESTIONS, FETCH_EVOLUTIVE_FILTERS_LIST, FETCH_EVOLUTIVE_STEP2_CROSSED_QUESTIONS, FETCH_SURVEY_CROSSED_QUESTIONS, CREATE_EVOLUTIVE_CROSS_CONFIG } from "../actions/evolutiveCross";

import { withFulFilled, withPending, withRejected } from "./commons";

// initial state
const INITIAL_STATE = {
  configuration: {
    step_one: {
      crossedQuestions: {
        running: false,
        error: null,
        payload: [],
      },
      surveysWithCrossedQuestions: {
        running: false,
        error: null,
        payload: []
      }
    },
    step_two: {
      crossedQuestions: {
        running: false,
        error: null,
        payload: [],
      }
    },
    step_three: {
      groupAlternatives: {
        running: false,
        error: null,
        payload: [],
      }
    },
    crossedQuestionsContent: {
      running: false,
      error: null,
      payload: [],
    },
    payload: {}, // { id_configuracao: number }
    configs: {
      running: false,
      error: null,
      payload: [],
    },
    filter_list: {
      running: false,
      error: null,
      payload: []
    }
  },
  // Resultados gerais utilizados pelo gráfico
  result: {
    running: false,
    error: null,
    payload: null,
  }
};


function fetchEvolutiveCrossedQuestionsStep2WithPending(state) {
  return {
    ...state,
    configuration: {
      ...state.configuration,
      step_two: {
        ...state.configuration.step_two,
        crossedQuestions: {
          ...state.configuration.step_two.crossedQuestions,
          running: true,
        }
      }
    }
  }
}

function fetchEvolutiveCrossedQuestionsStep2WithFulfilled(state, action) {
  return {
    ...state,
    configuration: {
      ...state.configuration,
      step_two: {
        ...state.configuration.step_two,
        crossedQuestions: {
          ...state.configuration.step_two.crossedQuestions,
          running: false,
          error: null,
          payload: action.payload,
        }
      }
    }
  }
}

function fetchEvolutiveCrossedQuestionsStep2WithRejected(state, action) {
  return {
    ...state,
    configuration: {
      ...state.configuration,
      step_two: {
        ...state.configuration.step_two,
        crossedQuestions: {
          ...state.configuration.step_two.crossedQuestions,
          running: false,
          payload: [],
          error: action.payload,
        }
      }
    }
  }
}

function fetchEvolutiveCrossedQuestionsWithPending(state) {
  return {
    ...state,
    configuration: {
      ...state.configuration,
      step_one: {
        ...state.configuration.step_one,
        crossedQuestions: {
          ...state.configuration.step_one.crossedQuestions,
          running: true,
        }
      }
    }
  }
}

function fetchEvolutiveCrossedQuestionsWithFulfilled(state, action) {
  return {
    ...state,
    configuration: {
      ...state.configuration,
      step_one: {
        ...state.configuration.step_one,
        crossedQuestions: {
          ...state.configuration.step_one.crossedQuestions,
          running: false,
          error: null,
          payload: action.payload,
        }
      }
    }
  }
}

function fetchEvolutiveCrossedQuestionsWithRejected(state, action) {
  return {
    ...state,
    configuration: {
      ...state.configuration,
      step_one: {
        ...state.configuration.step_one,
        crossedQuestions: {
          ...state.configuration.step_one.crossedQuestions,
          running: false,
          payload: [],
          error: action.payload,
        }
      }
    }
  }
}

function fetchSurveysCrossedQuestionsWithPending(state) {
  return {
    ...state,
    configuration: {
      ...state.configuration,
      step_one: {
        ...state.configuration.step_one,
        surveysWithCrossedQuestions: {
          ...state.configuration.step_one.surveysWithCrossedQuestions,
          running: true,
        }
      }
    }
  }
}

function fetchSurveysCrossedQuestionsWithFulfilled(state, action) {
  return {
    ...state,
    configuration: {
      ...state.configuration,
      step_one: {
        ...state.configuration.step_one,
        surveysWithCrossedQuestions: {
          ...state.configuration.step_one.surveysWithCrossedQuestions,
          running: false,
          error: null,
          payload: action.payload,
        }
      }
    }
  }
}

function fetchSurveysCrossedQuestionsWithRejected(state, action) {
  return {
    ...state,
    configuration: {
      ...state.configuration,
      step_one: {
        ...state.configuration.step_one,
        surveysWithCrossedQuestions: {
          ...state.configuration.step_one.surveysWithCrossedQuestions,
          running: false,
          payload: [],
          error: action.payload,
        }
      }
    }
  }
}

function fetchAlternativesAndQuestionsWithPending(state) {
  return {
    ...state,
    configuration: {
      ...state.configuration,
      step_one: {
        ...state.configuration.step_one,
        crossedQuestions: {
          ...state.configuration.step_one.crossedQuestions,
        }       
      },
      crossedQuestionsContent: {
        ...state.configuration.crossedQuestionsContent,
        running: true,
      }
    }
  }
}

function fetchAlternativesAndQuestionsWithFulfilled(state, action) {
  return {
    ...state,
    configuration: {
      ...state.configuration,
      step_one: {
        ...state.configuration.step_one,
        crossedQuestions: {
          ...state.configuration.step_one.crossedQuestions,
        }
      },
      crossedQuestionsContent: {
        ...state.configuration.crossedQuestionsContent,
        running: false,
        error: null,
        payload: action.payload
      }
    }
  }
}

function fetchAlternativesAndQuestionsWithRejected(state, action) {
  return {
    ...state,
    configuration: {
      ...state.configuration,
      step_one: {
        ...state.configuration.step_one,
        crossedQuestions: {
          ...state.configuration.step_one.crossedQuestions,
        }
      },
      crossedQuestionsContent: {
        ...state.configuration.crossedQuestionsContent,
        running: false,
        payload: [],
        error: action.payload,
      }
    }
  }
}

function fetchAlternativesByGroupsWithPending(state) {
  return {
    ...state,
    configuration: {
      ...state.configuration,
      step_three: {
        ...state.configuration.step_three,
        groupAlternatives: {
          ...state.configuration.step_three.groupAlternatives,
          running: true,
        }
      }
    }
  }
}

function fetchAlternativesByGroupsWithFulfilled(state, action) {
  return {
    ...state,
    configuration: {
      ...state.configuration,
      step_three: {
        ...state.configuration.step_three,
        groupAlternatives: {
          running: false,
          payload: action.payload.data,
          error: null,
        }
      }
    }
  }
}

function fetchAlternativesByGroupsWithRejected(state, action) {
  return {
    ...state,
    configuration: {
      ...state.configuration,
      step_three: {
        ...state.configuration.step_three,
        groupAlternatives: {
          ...state.configuration.step_three,
          running: false,
          error: action.payload,
        }
      }
    }
  }
}

/**
 * cria um novo estado respondendo à action
 * withPending(LIST_EVOLUTIVE_CROSS_CONFIG).
 *
 * Basicamente seta running = true
 */
function listConfigurationsPending(state) {
  const newState = { ...state };
  newState.configuration.configs = { ...newState.configuration.configs };
  newState.configuration.configs.running = true;
  return newState;
}

/**
 * define qual problema ocorreu na listagem
 * e set running como = false
 */
function listConfigurationsRejected(state, action) {
  const error = action.payload;

  const newState = { ...state };
  newState.configuration.configs = { ...newState.configuration.configs };
  newState.configuration.configs.running = false;
  newState.configuration.configs.error = error;
  return newState;
}

/**
 * Define a listagem das configuracoes, running=false / error = null
 */
function listConfigurationsFulfilled(state, action) {
  const newState = { ...state };
  newState.configuration.configs = { ...newState.configuration.configs };
  newState.configuration.configs.running = false;
  newState.configuration.configs.error = null;
  newState.configuration.configs.payload = {};
  const payloadKey = `${action.meta.clientId}_${action.meta.surveyId}_${action.meta.questionId}`;
  newState.configuration.configs.payload[payloadKey] = action.payload.data;
  return newState;
}


function fetchEvolutiveCreateConfigWithPending(state) {
  const newState = { ...state };
  newState.configuration.running = true;
  return newState;
}

function fetchEvolutiveCreateConfigWithRejected(state, action) {
  const error = action.payload;
  const newState = { ...state };
  newState.configuration.running = false;
  newState.configuration.error = error;
  return newState;
}

function fetchEvolutiveCreateConfigWithFulfilled(state, action) {
  const newState = { ...state };
  newState.configuration.running = false;
  newState.configuration.error = null;
  newState.configuration.payload = action.payload;
  return newState;
}


/**
 * cria um novo estado respondendo à action
 * withPending(FETCH_EVOLUTIVO_RESULT).
 *
 * Basicamente seta running = true
 */
 function fetchConfigResultsPending(state) {
  const newState = { ...state };
  newState.result = { ...newState.result };
  newState.result.running = true;
  return newState;
}

/**
 * define qual problema ocorreu no fetch de resultados
 * e set running como = false
 */
function fetchConfigResultsRejected(state, action) {
  const error = action.payload;

  const newState = { ...state };
  newState.result = { ...newState.result };
  newState.result.running = false;
  newState.result.error = error;
  return newState;
}

/**
 * Define os resultados da configuracaoSelecionada, running=false / error = null
 */
function fetchConfigResultsFulfilled(state, action) {
  const newResultPayload = {};
  newResultPayload[action.meta.configId] = action.payload.data;

  const newState = { ...state };
  newState.result = { ...newState.result };
  newState.result.running = false;
  newState.result.error = null;
  newState.result.payload = newResultPayload;

  return newState;
}

function fetchFilterListWithPending(state) {
  return {
    ...state,
    configuration: {
      ...state.configuration,
      filter_list: {
        ...state.configuration.filter_list,
        running: true,
      }
    }
  }
}

function fetchFilterListWithFulfilled(state, action) {
  return {
    ...state,
    configuration: {
      ...state.configuration,
      filter_list: {
        ...state.configuration.filter_list,
        running: false,
        payload: action.payload.data,
        error: null,
      }
    }
  }
}

function fetchFilterListWithRejected(state, action) {
  return {
    ...state,
    configuration: {
      ...state.configuration,
      filter_list: {
        ...state.configuration.filter_list,
        running: false,
        error: action.payload,
      }
    }
  }
}

// executer
const execute = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case withPending(FETCH_EVOLUTIVE_STEP2_CROSSED_QUESTIONS):
      return fetchEvolutiveCrossedQuestionsStep2WithPending(state);
    case withFulFilled(FETCH_EVOLUTIVE_STEP2_CROSSED_QUESTIONS):
      return fetchEvolutiveCrossedQuestionsStep2WithFulfilled(state, action);
    case withRejected(FETCH_EVOLUTIVE_STEP2_CROSSED_QUESTIONS):
      return fetchEvolutiveCrossedQuestionsStep2WithRejected(state, action);

    case withPending(FETCH_EVOLUTIVE_CROSSED_QUESTIONS):
      return fetchEvolutiveCrossedQuestionsWithPending(state);
    case withFulFilled(FETCH_EVOLUTIVE_CROSSED_QUESTIONS):
      return fetchEvolutiveCrossedQuestionsWithFulfilled(state, action);
    case withRejected(FETCH_EVOLUTIVE_CROSSED_QUESTIONS):
      return fetchEvolutiveCrossedQuestionsWithRejected(state, action);

    case withPending(FETCH_SURVEY_CROSSED_QUESTIONS):
      return fetchSurveysCrossedQuestionsWithPending(state);
    case withFulFilled(FETCH_SURVEY_CROSSED_QUESTIONS):
      return fetchSurveysCrossedQuestionsWithFulfilled(state, action);
    case withRejected(FETCH_SURVEY_CROSSED_QUESTIONS):
      return fetchSurveysCrossedQuestionsWithRejected(state, action);

    case withPending(FETCH_EVOLUTIVE_CROSSED_ALTERNATIVES_AND_QUESTIONS):
      return fetchAlternativesAndQuestionsWithPending(state);
    case withFulFilled(FETCH_EVOLUTIVE_CROSSED_ALTERNATIVES_AND_QUESTIONS):
      return fetchAlternativesAndQuestionsWithFulfilled(state, action);
    case withRejected(FETCH_EVOLUTIVE_CROSSED_ALTERNATIVES_AND_QUESTIONS):
      return fetchAlternativesAndQuestionsWithRejected(state, action);
      
    case withPending(FETCH_ALTERNATIVES_BY_GROUP_QUESTIONS):
      return fetchAlternativesByGroupsWithPending(state);
    case withFulFilled(FETCH_ALTERNATIVES_BY_GROUP_QUESTIONS):
      return fetchAlternativesByGroupsWithFulfilled(state, action);
    case withRejected(FETCH_ALTERNATIVES_BY_GROUP_QUESTIONS):
      return fetchAlternativesByGroupsWithRejected(state, action);
      
    case withPending(LIST_EVOLUTIVE_CROSS_CONFIG):
      return listConfigurationsPending(state);
    case withFulFilled(LIST_EVOLUTIVE_CROSS_CONFIG):
      return listConfigurationsFulfilled(state, action);
    case withRejected(LIST_EVOLUTIVE_CROSS_CONFIG):
      return listConfigurationsRejected(state, action);

    /**
     * Configraçao
    */
    case withPending(CREATE_EVOLUTIVE_CROSS_CONFIG):
      return fetchEvolutiveCreateConfigWithPending(state);
    case withFulFilled(CREATE_EVOLUTIVE_CROSS_CONFIG):
      return fetchEvolutiveCreateConfigWithFulfilled(state, action);
    case withRejected(CREATE_EVOLUTIVE_CROSS_CONFIG):
      return fetchEvolutiveCreateConfigWithRejected(state, action);
      
    /**
     * Resultados
     */
    case withPending(FETCH_EVOLUTIVE_CROSS_RESULT):
      return fetchConfigResultsPending(state, action);
    case withRejected(FETCH_EVOLUTIVE_CROSS_RESULT):
      return fetchConfigResultsRejected(state, action);
    case withFulFilled(FETCH_EVOLUTIVE_CROSS_RESULT):
      return fetchConfigResultsFulfilled(state, action);

    /**
     * Filtros
     */
    
    case withPending(FETCH_EVOLUTIVE_FILTERS_LIST):
      return fetchFilterListWithPending(state);
      case withFulFilled(FETCH_EVOLUTIVE_FILTERS_LIST):
        return fetchFilterListWithFulfilled(state, action);
      case withRejected(FETCH_EVOLUTIVE_FILTERS_LIST):
        return fetchFilterListWithRejected(state, action);

    default:
      return state;
  }
};

export default execute;
